import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials, company } from "../mock/mock";
import Reveal from "./Reveal";

const Testimonials = () => {
  return (
    <section className="py-20 bg-[#f7f9fc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#C9A227] font-semibold text-sm uppercase tracking-wider">
            Témoignages
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mt-2 mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-gray-600">
            Découvrez les témoignages de nos clients satisfaits qui nous font confiance
            pour leurs déménagements.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 100}
              className="bg-white rounded-2xl p-7 shadow-sm border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <Quote size={32} className="text-[#C9A227]/30 mb-3" />
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={16} className="fill-[#C9A227] text-[#C9A227]" />
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed flex-1">“{t.text}”</p>
              <div className="mt-5 pt-4 border-t border-gray-100">
                <p className="font-semibold text-[#1B2A4A]">{t.name}</p>
                <p className="text-xs text-gray-400">
                  {t.location} • {t.year}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={company.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A] hover:text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200"
          >
            <Star size={18} /> Laisser un avis
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
